<template>
  <div>
    <h1 class="pb-3">Compliance Checks Supporting Documents</h1>
    <FileUpload
      :isMultiple="true"
      @onUploadSuccess="handleUploadSuccess"
      @removeFile="onRemoveFile"
      @unselectFile="onRemoveFile"
      @show="onShow"
      @selectFile="selectFile"
      :uploadingUrl="getAddFileUrl"
      :fileTypes="[
        '.pdf',
        '.jpeg',
        '.jpg',
        '.png',
        '.doc',
        '.docx',
        '.xlsx',
        '.ppt'
      ]"
      :files="files"
      :id="documentId"
      :isLoading="isLoading"
      :disableAutoProceed="false"
      customActions
    />
    <PDFViewFull :data="fileDialog" />
  </div>
</template>

<script>
import FileUpload from "@/components/common/FileUpload";
import APIService from "@/services/APIService";
import { DELETE_WORKER_COMPLIANCE_DOC } from "@/store/modules/workers/action-types";
import { mapActions, mapState } from "vuex";
import PDFViewFull from "@/components/common/PDFViewFull";
import { getToken } from "@/services/utils";

export default {
  props: {
    /**
     *  Data object
     */
    currentWorker: {
      type: Object,
      required: true
    },
    permissions: Object,
    isUpdate: Boolean
  },
  components: {
    FileUpload,
    PDFViewFull
  },
  data() {
    return {
      isLoading: false,
      files: Array.isArray(this.currentWorker.complianceSupportingFiles)
        ? [...this.currentWorker.complianceSupportingFiles]
        : [],
      fileDialog: {
        title: "",
        dialog: false,
        src: ""
      },
      isFileUploaded: false
    };
  },
  computed: {
    ...mapState("workers", {
      currentWorkerId: state => state.currentWorkerId
    }),
    documentId() {
      return `compliance_doc${this.currentWorkerId}`;
    },
    getAddFileUrl() {
      const host = APIService.host;
      return `${host}/users/${this.currentWorkerId}/compliance-documents`;
    }
  },
  async mounted() {
    await this.$store.dispatch(
      "workers/FETCH_WORKER_COMPLIANCE_DOCS",
      this.currentWorkerId
    );
    const fromStore =
      this.$store.state.workers.currentWorker.complianceSupportingFiles || [];
    this.files = [...fromStore];
    this.currentWorker.complianceSupportingFiles = [...this.files];
  },
  methods: {
    ...mapActions("workers", {
      removeFile: DELETE_WORKER_COMPLIANCE_DOC
    }),
    selectFile({ uppyInstance, file }) {
      uppyInstance.setFileState(file.id, {
        xhrUpload: { endpoint: this.getAddFileUrl }
      });
      uppyInstance.upload().then(() => {
        this.isFileUploaded = true;
        this.$forceUpdate();
      });
    },
    async onRemoveFile(payload) {
      const file = payload?.file ?? payload;
      this.isLoading = true;
      try {
        await this.removeFile({
          workerId: this.currentWorkerId,
          docId: file.id
        });
        this.fileRemoved(file.id);
        if (this.files.length === 0) this.isFileUploaded = false;
      } finally {
        this.isLoading = false;
      }
    },
    fileRemoved(docId) {
      this.files = this.files.filter(f => String(f.id) !== String(docId));
      this.currentWorker.complianceSupportingFiles = [...this.files];
      this.currentWorker.complianceSupportingFile =
        this.files.length > 0 ? this.files[0] : null;

      this.handleChange();
    },
    handleChange() {
      this.$emit("onChange", this.currentWorker);
    },
    handleUploadSuccess(uploaded) {
      const arr = Array.isArray(uploaded) ? uploaded : [uploaded];
      const seen = new Set();
      this.files = [...this.files, ...arr]
        .filter(f => f && f.id != null)
        .filter(f => (seen.has(String(f.id)) ? false : seen.add(String(f.id))));
      this.currentWorker.complianceSupportingFiles = [...this.files];
      this.$emit("onChange", this.currentWorker);
    },
    async onShow(file) {
      const token = getToken();
      this.fileDialog.src = `${file.url}?token=${token}`;
      this.fileDialog.title = file.fileName;
      this.fileDialog.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
